import { render } from "./EnduserChatTalksView.vue?vue&type=template&id=5e081644"
import script from "./EnduserChatTalksView.vue?vue&type=script&lang=js"
export * from "./EnduserChatTalksView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__